/**
 * This sets defaults and handles maintaining our auth token/params
 * between http requests.
 */

import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource);


const userSearch = Vue.resource('shares/user_search{/id}');



export default userSearch;



// WEBPACK FOOTER //
// ./src/resources/userSearch.js